export const locale = {
    lang: 'en',
    data: {
        confirm_dialog: {
            cancel: 'Cancel',
            confirm: 'Confirm'
        }
    }
};
